<template lang="pug">
  form.b-project-create(v-if="project")
    ._part
      FormBlock._main(ref="mainFields")
        ._top
          h2._title.-ordered Основное
        ._body
          BaseField._name(
            v-for="(field, name) in mainFields"
            v-model="field.value"
            v-bind="field"
            :key="name"
            :class="{ [name]: true }"
            @change="onInputChange(name)"
            )
          WysiwygToolbar._toolbar#toolbar
          WysiwygEditor._editor(toolbar="#toolbar" label="Описание проекта" v-model="project.description" @change="onInputChange()" @dropFiles="additionalFiles = $event")
          ProjectFileUploader(v-if="mode === 'edit' || !isShort" :project="project.id" :publish="!project.isDraft" :filesToUpload="additionalFiles")._files
      FormBlock._aside.-center
        ._top
          h2._title Аватар проекта
        AvatarEditable(:avatar="project.avatar" @change="changeAvatar" placeholder="no-avatar-project")
    ._part(v-if="mode === 'edit' || !isShort")
      FormBlock._main(ref="infoFields")
        ._top.-align-left
          h2._title.-ordered Данные проекта
          BaseTooltip(text="Вы можете выбрать заказчика или подписчика из числа своих контактов, пригласить специалиста с платформы или пригласить в проект. После создания проекта подписчики получат приглашение по e-mail.")
        ._info-fields
          BaseField._info-field(
            v-for="(field, name) in infoFields"
            v-model="field.value"
            v-bind="field"
            :key="name"
            :class="{ [name]: true }"
            labelOuter
            @change="onInputChange(name)"
          )
        RoomSelect(v-model="project.objectRooms" :isCreating="mode === 'create'" ref="roomSelect" @input="onInputChange()")
      FormBlock._aside
        ._help Задачи создаются только при создании проекта. При редактировании проекта и помещений состав задач и блоков меняться не будет.
    ._part
      ._main
        ._bottom
          //Btn(blue round v-if="mode === 'create'" style="margin-right: auto" @click="isShort = !isShort") {{ isShort ? 'Развернуть полную форму проекта' : 'Свернуть полную форму проекта' }}
          Btn(green round v-if="mode === 'create'" @click="onPublishClick") Создать проект
          Btn(grey round v-if="mode === 'edit'" @click="onCancelClick") Отмена
          Btn(green round v-if="mode === 'edit'" @click="onSaveClick") Обновить проект
</template>

<script>
import projectApi from '@/api/project';
import form from '@/utils/form';

import BaseField from '@/components/BaseField.vue';
import WysiwygEditor from '@/components/WysiwygEditor.vue';
import WysiwygToolbar from '@/components/WysiwygToolbar.vue';
import FormBlock from '@/components/FormBlock.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseTooltip from '@/components/BaseTooltip.vue';
import RoomSelect from '@/components/RoomSelect.vue';
import ProjectFileUploader from '@/components/ProjectFileUploader.vue';
import UserUniversalTile from '@/components/UserUniversalTile.vue';
import UserInvitations from '@/components/UserInvitations.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'ProjectCreateForm',
  components: {
    ProjectFileUploader,
    RoomSelect,
    FormBlock,
    BaseField,
    CommonSection,
    WysiwygEditor,
    WysiwygToolbar,
    BaseTooltip,
    UserUniversalTile,
    UserInvitations,
    AvatarEditable,
  },
  data() {
    return {
      project: null,
      objectRooms: null,
      isShort: false, // todo purge
      additionalFiles: [],
      /* eslint-disable */
      mainFields: {
        name: form.createFieldObject('text', 'Название проекта', '', { required: 'Укажите название проекта' }),
        dateStart: form.createFieldObject('date', 'Старт', ''),
        dateFinish: form.createFieldObject('date', 'Финиш', ''),
      },
      infoFields: {
        objectArea:           form.createFieldObject('float',     'Площадь',              '',    { number: 'Число' }, [], { unit: 'м²' }),
        pricePerSquareMeter:  form.createFieldObject('int',       'Цена',                 '',    { number: 'Число' }, [], { unit: 'руб/м²' }),
        objectType:           form.createFieldObject('select',    'Вид объекта',          null,  {}, form.makeSelectOptionsFromObject({ apartment: 'Квартира', flat: 'Многоквартирный дом', house: 'Частный дом', social: 'Социальный объект', commercial: 'Коммерческая недвижимость', other: 'Другое', })),
        objectFloorsQty:      form.createFieldObject('int',       'Этажей',               '',    { number: 'Число' }),
        objectRoomsQty:       form.createFieldObject('int',       'Количество помещений', '',    { number: 'Число' }),
        objectAddress:        form.createFieldObject('textarea',  'Адрес объекта',        '',    {}),
      },
      /* eslint-enable */
    };
  },
  computed: {
    mode() { return this.$route.params.projectId ? 'edit' : 'create'; },
  },
  created() {
    const promise = this.mode === 'create'
      ? projectApi.fetchDraft()
      : projectApi.fetchItem(this.$route.params.projectId, true);

    promise.then(this.onProjectFetched);
  },
  watch: {
    isShort(val) {
      if (this.mode === 'edit') return;

      this.project.objectRooms ??= {};
      if (Array.isArray(this.project.objectRooms)) {
        this.project.objectRooms = {};
      }

      this.project.objectRooms.useRooms = !val;
      this.updateProject();
    },
  },
  methods: {
    onProjectFetched(response) {
      this.project = response;
      form.setValues(this.mainFields, response);
      form.setValues(this.infoFields, response);
      document.title = this.mode === 'create' ? 'Новый проект' : this.project.name;
    },
    onInputChange(fieldName) {
      form.validateField(this.mainFields, fieldName);
      form.validateField(this.infoFields, fieldName);

      const formHasErrors = form.hasErrors(this.mainFields) || form.hasErrors(this.infoFields);

      if (formHasErrors || this.mode === 'edit') {
        return;
      }

      this.updateProject();
    },
    validateAndScroll() {
      form.validate(this.mainFields);
      form.validate(this.infoFields);

      if (form.hasErrors(this.mainFields)) {
        this.$refs.mainFields.$el.scrollIntoView({ behavior: 'smooth' });
        return false;
      }

      if (form.hasErrors(this.infoFields)) {
        this.$refs.infoFields.$el.scrollIntoView({ behavior: 'smooth' });
        return false;
      }

      if (this.$refs.roomSelect && !this.$refs.roomSelect.validate()) {
        this.$refs.roomSelect.$el.scrollIntoView({ behavior: 'smooth' });
        return false;
      }

      return true;
    },
    onPublishClick() {
      if (!this.validateAndScroll()) {
        return;
      }

      projectApi.publish(this.project.id).then(() => {
        this.$router.push({ name: 'project-stages', params: { projectId: this.project.id } });
      });
    },
    onSaveClick() {
      if (!this.validateAndScroll()) {
        return;
      }

      this.updateProject();
    },
    onCancelClick() {
      if (this.mode === 'edit') {
        this.$router.push({ name: 'project-stages', params: { projectId: this.project.id } });
      }
    },
    updateProject() {
      const formData = {
        ...this.project,
        ...form.getValues(this.mainFields),
        ...form.getValues(this.infoFields),
        avatar: this.project.avatar?.['@id'] ?? null,
      };

      delete formData.author;
      delete formData.members;

      const isEdit = this.mode === 'edit';
      projectApi.update(this.project.id, formData, isEdit).then(() => {
        if (isEdit) {
          this.$store.commit('project/setProject', null);
          this.$router.push({ name: 'project-stages', params: { projectId: this.project.id } });
        }
      });
    },
    async changeAvatar(avatar) {
      await projectApi.update(this.project.id, { avatar: avatar?.['@id'] ?? null }, true);
      this.project.avatar = avatar;
    },
  },
};
</script>

<style lang="scss">
@import "../assets/styles/helpers/functions";

.project-create {
  --column-gutter: 36px;
  --row-gutter: 30px;

  &__part {
    display: grid;
    align-items: flex-start;
    column-gap: var(--column-gutter);
    grid-column: 12 span;
    grid-template-columns: repeat(11, 1fr) minmax(105px, 1fr);
  }

  &__bottom {
    display: flex;
    justify-content: flex-end;
    gap: var(--row-gutter);
  }

  &__main {
    grid-column: 9 span;
    margin-bottom: var(--row-gutter);
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;

    &--align-left {
      align-items: center;
      justify-content: flex-start;
    }
  }

  &__title {
    font-size: 18px;
    margin-right: 8px;
    color: var(--color-super-dark);

    &--ordered:before {
      content: counter(number);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 100%;
      counter-increment: number;
      margin-right: 16px;
      background-color: var(--color-super-light);
    }
  }

  &__body {
    display: grid;
    align-items: flex-start;
    column-gap: 30px;
    row-gap: 16px;
    grid-template-columns: repeat(12, 1fr);
    margin-bottom: 9px;
  }

  &__toolbar {
    grid-column: 9 span;
    grid-row: 2;
  }

  &__editor {
    grid-column: 12 span;
  }

  .name {
    grid-column: 9 span;
  }

  .dateStart, .dateFinish {
    grid-column: 10 / span 3;
  }

  &__files {
    grid-column: 12 span;
  }

  &__aside {
    grid-column: 3 span;
    --vertical-padding: 32px;
    padding: 35px 32px 30px 32px;
    background: var(--color-white);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-bottom: var(--row-gutter);

    &--center {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__desc {
    color: var(--color-middle-gray);
    font-size: 12px;
    line-height: 15px;
    letter-spacing: .01em;
    margin-bottom: 24px;
  }

  &__info-fields {
    display: grid;
    column-gap: 36px;
    row-gap: 16px;
    grid-template-columns: repeat(6,1fr);
    margin-bottom: 20px;
  }

  &__info-field {
    grid-column: 2 span;

    &.objectAddress {
      grid-column: 6 span;
    }
  }

  &__help {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #1E3147;
  }

  @media (max-width: 1600px) {
    &__part {
      column-gap: 24px;
    }

    & .name {
      grid-column: 8 span;
    }

    & .dateStart,
    & .dateFinish {
      grid-column: 9 / span 4;
    }

    &__toolbar {
      grid-column: 8 span;
      grid-row: 2;
    }

    &__info-fields {
      gap: 12px;
    }
  }

  @media (max-width: 1279px) {
    .name {
      grid-column: 12 span;
    }

    .dateStart, .dateFinish {
      grid-column: 6 span;
    }

    &__toolbar {
      grid-column: 12 span;
      grid-row: 3;
    }

    &__info-field {
      grid-column: 3 span;
    }
  }

  @media (max-width: 1000px) {
    column-gap: 6px;
    &__part {
      display: block;
    }

    &__body {
      column-gap: 6px;
      row-gap: 8px;
    }
  }

  @media (max-width: 576px) {
    &__main, &__aside {
      margin-bottom: 16px;
    }

    &__top {
      margin-bottom: 20px;
    }

    &__toolbar {
      display: none;
    }

    &__info-field {
      grid-column: 6 span;
    }
  }
}

</style>
